import React from 'react';
import SVGIcons from '../../assets/images/icons/svgIcons';
import LandingDrawer from './mainHeader/mainHeaderDrawer';



const Header = () => {
  
  


  return (
    <>
    {/* {currentURL === '/' ? <> */}
    
    <div className='header-revamp-wrp f-wrp'>
      <div className='header-info-ribbon f-wrp'>
        <div className='container'>
          <ul>
            <li><SVGIcons.MapPointer /> Building 3b, Street 69a, Jumeirah 1, Dubai, UAE</li>
            <li><a href="tel:+971568816886"><SVGIcons.PhoneIcon /> +971-56-881-6886</a></li>
            <li><a href="mailto:admin@propshop.ai"><SVGIcons.MailIcon /> admin@propshop.ai</a></li>
          </ul>
        </div>
      </div>
    </div>
      <LandingDrawer />

      {/* <div className='header-nav-wrp f-wrp'>
        <LandingDrawer />
      </div> */}
       {/* : <div className={`${scroll ? "main-header scrolled" : "main-header"} project-main-header ${currentURL === '/' ? 'inside-home-wrp' : 'outside-home-wrp'} ${urlSeparator === 'fractional' ? 'inside-fractional-wrp' : null} ${urlSeparator === 'traditional' ? 'inside-traditional-wrp' : null} f-wrp`}>
         <div className="container">
           <DrawerAppBar />
         </div>
       </div>}</> */}

    </>



  )
}

export default Header;